import React from "react";

import SyDialog from "../../../components/SyDialog";
import { formatMoney } from "../financeMoney";

const DetailRow = ({ label, value }) =>
  value === null || value === undefined || value === "" ? null : (
    <div className="fin-detail-row">
      <span className="fin-detail-label">{label}</span>
      <span className="fin-detail-value">{value}</span>
    </div>
  );

const TransactionDetailDialog = ({ transaction, onClose, onViewOrder }) => {
  if (!transaction) return null;

  const { fx } = transaction;

  return (
    <SyDialog
      open
      title="Transaction Details"
      size="sm"
      onClose={onClose}
      footer={
        transaction.orderId != null ? (
          <div className="fin-detail-actions">
            <button
              type="button"
              className="sy-flow-btn sy-flow-btn-primary"
              onClick={() => onViewOrder(transaction.orderId)}
            >
              View Order
            </button>
          </div>
        ) : null
      }
    >
      <div className="fin-detail-hero">
        <p
          className={`fin-detail-amount fin-detail-amount-${
            transaction.impact === "C" ? "credit" : "debit"
          }`}
        >
          {transaction.signedAmount}
        </p>

        <p className="fin-detail-caption">{transaction.title}</p>
      </div>

      <div className="fin-detail-rows">
        <DetailRow label="Status" value={transaction.statusLabel} />
        <DetailRow label="Type" value={transaction.purposeLabel} />
        <DetailRow label="Method" value={transaction.card?.label ?? transaction.gatewayLabel} />
        <DetailRow
          label="Date"
          value={[transaction.dateLabel, transaction.timeLabel].filter(Boolean).join(" · ")}
        />
        <DetailRow label="Transaction ID" value={`#${transaction.id}`} />
        <DetailRow
          label="Order"
          value={transaction.orderId != null ? `#${transaction.orderId}` : null}
        />
      </div>

      {fx?.converted && (
        <div className="fin-detail-rows fin-detail-fx">
          <h4 className="fin-detail-subhead">Conversion</h4>

          <DetailRow label="Requested" value={fx.requested ? formatMoney(fx.requested) : null} />
          <DetailRow label="Charged" value={fx.billed ? formatMoney(fx.billed) : null} />
          <DetailRow label="Rate" value={fx.rate != null ? String(fx.rate) : null} />
          <DetailRow
            label="Balance before"
            value={fx.balanceBefore ? formatMoney(fx.balanceBefore) : null}
          />
          <DetailRow
            label="Balance after"
            value={fx.balanceAfter ? formatMoney(fx.balanceAfter) : null}
          />
        </div>
      )}
    </SyDialog>
  );
};

export default TransactionDetailDialog;
